<!-- ════════════════════════════════════════════════════════════
     FILE MANAGER  –  Google Drive style
     ════════════════════════════════════════════════════════════ -->

<!-- ── Main shell (only when ready) ─────────────────────────── -->
<div class="fm" *ngIf="ready" [class.fm--dragging]="isDragging">

  <!-- Drop overlay -->
  <div class="fm-drop" *ngIf="isDragging">
    <div class="fm-drop-card">
      <mat-icon class="fm-drop-card__icon">cloud_upload</mat-icon>
      <p class="fm-drop-card__text">Suelta aquí para subir</p>
    </div>
  </div>

  <!-- ── Top bar ──────────────────────────────────────────────── -->
  <header class="fm-bar">

    <div class="fm-bar__start">
      <button mat-icon-button class="fm-back-btn" *ngIf="path !== 'files'" (click)="comeBack()" matTooltip="Volver">
        <mat-icon>arrow_back</mat-icon>
      </button>

      <nav class="fm-crumb">
        <ng-container *ngFor="let seg of breadcrumbSegments; let last = last; let i = index">
          <!-- Root: icono en caja + etiqueta "Archivos" -->
          <ng-container *ngIf="i === 0">
            <div class="fm-crumb__root-wrap">
              <mat-icon class="fm-crumb__root">storage</mat-icon>
            </div>
            <span *ngIf="last" class="fm-crumb__current fm-crumb__root-label">Archivos</span>
            <button *ngIf="!last" class="fm-crumb__btn fm-crumb__root-label" (click)="navigateToBreadcrumb(seg.path)">Archivos</button>
          </ng-container>
          <!-- Separator + segment -->
          <ng-container *ngIf="i > 0">
            <mat-icon class="fm-crumb__sep">chevron_right</mat-icon>
            <span *ngIf="last" class="fm-crumb__current">{{ seg.label }}</span>
            <button *ngIf="!last" class="fm-crumb__btn" (click)="navigateToBreadcrumb(seg.path)">{{ seg.label }}</button>
          </ng-container>
        </ng-container>
      </nav>
    </div>

    <div class="fm-bar__end">
      <!-- Search pill -->
      <label class="fm-search" [class.fm-search--active]="searchText">
        <mat-icon class="fm-search__icon">search</mat-icon>
        <input class="fm-search__input" [(ngModel)]="searchText" placeholder="Buscar en archivos…" />
        <button *ngIf="searchText" mat-icon-button class="fm-search__clear" (click)="searchText = ''">
          <mat-icon>close</mat-icon>
        </button>
      </label>

      <!-- New folder -->
      <button mat-button class="fm-btn-ghost" (click)="openDialog()" matTooltip="Nueva carpeta">
        <mat-icon>create_new_folder</mat-icon>
        <span class="fm-btn-ghost__label">Nueva carpeta</span>
      </button>

      <!-- Upload -->
      <button mat-flat-button class="fm-btn-primary" (click)="uploadFile()">
        <mat-icon>file_upload</mat-icon>
        Subir
      </button>

      <!-- Repair files (admin only) -->
      <button mat-icon-button class="fm-icon-btn" matTooltip="Reparar ficheros (Admin)"
        *ngIf="isAdmin" (click)="openRepairDialog()">
        <mat-icon>build</mat-icon>
      </button>
    </div>

  </header>

  <!-- ── OCR banner (facturas folder only) ───────────────────── -->
  <div class="fm-ocr-bar" *ngIf="path.includes('Facturas%20sin%20contabilizar')">
    <mat-icon class="fm-ocr-bar__icon">flash_on</mat-icon>
    <span class="fm-ocr-bar__label">Procesar automáticamente al subir</span>
    <mat-slide-toggle [(ngModel)]="autoProcesarFacturas" (change)="onToggleAutoProcesar()" color="accent"></mat-slide-toggle>
    <span class="fm-ocr-bar__sep"></span>
    <mat-icon class="fm-ocr-bar__icon fm-ocr-bar__icon--sm">find_in_page</mat-icon>
    <span class="fm-ocr-bar__pages">{{ ocrAvailable }} páginas OCR disponibles</span>
    <span class="fm-ocr-bar__pages" *ngIf="ocrPagesTotal > 0">
      · {{ ocrPagesUsed }}/{{ ocrPagesTotal }} usadas este año<ng-container *ngIf="ocrWindowEnd"> · se renueva el {{ ocrWindowEnd | date:'dd/MM/yyyy' }}</ng-container>
    </span>
    <mat-icon class="fm-ocr-bar__help"
      title="Cuando está activo, cada fichero que subas se procesará automáticamente (OCR + generación de gasto).">
      help_outline
    </mat-icon>
  </div>

  <!-- ── Main content ─────────────────────────────────────────── -->
  <main class="fm-main">

    <!-- Card: tabla + empty states + footer unidos -->
    <div class="fm-card">

      <!-- File list -->
      <app-table
        *ngIf="filteredFiles.length > 0"
        [columns]="headerTable"
        [dataSource]="filteredFiles"
        [hasButton]="true"
        [hasSelect]="true"
        [hasHeaderActions]="true"
        [actionsTemplate]="actionsButtons"
        [hasRowClick]="true"
        [headerActionsTemplate]="headerActionsButtons"
        (rowClick)="returnElement($event)">
      </app-table>

      <!-- Empty: folder is truly empty -->
      <div class="fm-empty" *ngIf="filteredFiles.length === 0 && !searchText">
        <div class="fm-empty__art">
          <mat-icon>folder_open</mat-icon>
        </div>
        <h3 class="fm-empty__title">Esta carpeta está vacía</h3>
        <p class="fm-empty__sub">Arrastra archivos aquí o usa el botón&nbsp;<strong>Subir</strong></p>
        <button mat-flat-button class="fm-btn-primary fm-btn-primary--lg" (click)="uploadFile()">
          <mat-icon>file_upload</mat-icon>
          Subir primer archivo
        </button>
      </div>

      <!-- Empty: search returned nothing -->
      <div class="fm-empty" *ngIf="filteredFiles.length === 0 && searchText">
        <div class="fm-empty__art fm-empty__art--muted">
          <mat-icon>search</mat-icon>
        </div>
        <h3 class="fm-empty__title">Sin resultados</h3>
        <p class="fm-empty__sub">No hay archivos que coincidan con "<strong>{{ searchText }}</strong>"</p>
        <button mat-stroked-button class="fm-btn-outline" (click)="searchText = ''">Limpiar búsqueda</button>
      </div>

      <!-- Footer pegado al card -->
      <div class="fm-card__foot">
        <div class="fm-storage">
          <mat-icon class="fm-storage__icon">cloud</mat-icon>
          <div class="fm-storage__track">
            <div class="fm-storage__fill"
              [style.width.%]="storagePercent"
              [class.fm-storage__fill--warn]="storagePercent > 75"
              [class.fm-storage__fill--full]="storagePercent > 90">
            </div>
          </div>
          <span class="fm-storage__text">{{ dataSource.storageSpentString }} de {{ dataSource.storageCapacityString }}</span>
        </div>
        <app-paginator (changePage)="onChangePage($event)" [actualPage]="actualPage" [totalPages]="totalPages"></app-paginator>
      </div>

    </div>

  </main>

</div>


<!-- ── Skeleton loading ──────────────────────────────────────── -->
<div class="fm-skeleton" *ngIf="ready === false">
  <div class="fm-skeleton__bar"></div>
  <div class="fm-skeleton__body">
    <div class="fm-skeleton__row" *ngFor="let i of [1,2,3,4,5,6,7]"
         [style.width]="(100 - (i % 3) * 8) + '%'"></div>
  </div>
</div>


<!-- ══════════════════════════════════════════════════════════════
     ACTION TEMPLATES
     ══════════════════════════════════════════════════════════════ -->

<ng-template #headerActionsButtons let-selected="selected">
  <button mat-menu-item class="fm-menu-item fm-menu-item--danger" (click)="deleteAll(selected)">
    <mat-icon>delete_sweep</mat-icon>
    <span>Eliminar seleccionados</span>
  </button>
  <ng-container *ngIf="path.includes('Facturas%20sin%20contabilizar')">
    <button mat-menu-item class="fm-menu-item" (click)="ocrAll(selected)">
      <mat-icon>receipt</mat-icon>
      <span>Generar gasto (OCR)</span>
    </button>
  </ng-container>
</ng-template>

<ng-template #actionsButtons let-row="row">
  <ng-container *ngIf="row">
    <button mat-menu-item class="fm-menu-item" (click)="copyTo(row.uid)">
      <mat-icon>content_copy</mat-icon>
      <span>Copiar</span>
    </button>
    <button mat-menu-item class="fm-menu-item" (click)="moveTo(row.uid, row.isDirectory, row.type)">
      <mat-icon>open_with</mat-icon>
      <span>Mover</span>
    </button>
    <button mat-menu-item class="fm-menu-item" (click)="download(row.uid, row.note, row.isDirectory, row.type)">
      <mat-icon>file_download</mat-icon>
      <span>Descargar</span>
    </button>
    <button mat-menu-item class="fm-menu-item" (click)="renameFile(row.uid, row.isDirectory, row.type)">
      <mat-icon>edit</mat-icon>
      <span>Renombrar</span>
    </button>
    <mat-divider></mat-divider>
    <button mat-menu-item class="fm-menu-item fm-menu-item--danger" (click)="delete(row.uid)">
      <mat-icon>delete</mat-icon>
      <span>Eliminar</span>
    </button>
    <ng-container *ngIf="canOCR && row.ocrStatusRetry && path.includes('Facturas%20sin%20contabilizar')">
      <button mat-menu-item class="fm-menu-item" (click)="ocr(row.uid)">
        <mat-icon>find_in_page</mat-icon>
        <span>Generar gasto</span>
      </button>
    </ng-container>
  </ng-container>
</ng-template>
